module.exports = __webpack_public_path__ + "img/attags.99581726.png";